import { gql, useMutation } from '@apollo/client';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import * as K from 'common/constants';
import { accountDataState } from 'components/account/account.state';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';

const LOGOUT = gql`
  mutation logout {
    logout
  }
`;

/**
 * This hook should be used on all pages that requires logout,
 * because logout can contain additional cleanup logic
 */
export const useLogout = () => {
  const accountData = useRecoilValue(accountDataState);
  const { isSingularityXDRUser, S1ConsoleURL } = accountData;
  const setPageAlert = useSetRecoilState(pageAlertConfigState);

  const [logout, { client }] = useMutation(LOGOUT, {
    onCompleted: () => {
      // cleanup logic
      client?.clearStore();

      if (isSingularityXDRUser && S1ConsoleURL) {
        window.location.assign(`${S1ConsoleURL}/login`);
      } else {
        window.location.assign(K.ROUTE.LOG_IN);
      }
    },
    onError: () => {
      setPageAlert({
        variant: PageAlertVariant.ERROR,
        message: 'Could not perform logout request',
      });
    },
  });

  return logout;
};
